import { action, computed, observable } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class GridLayoutModel {
  // 기본 레이아웃 정보
  @observable
  _maxBaseRows: number = 4;
  @observable
  _maxBaseColumns: number = 4;

  @observable
  _currentBaseRows: number = 3;
  @observable
  _currentBaseColumns: number = 4;

  @observable
  _previousBaseRows: number = -1;
  @observable
  _previousBaseColumns: number = -1;

  // 출력되는 기본레이아웃 개수
  // 실제 출력 되는 화면은 기본레이아웃 * n
  @observable
  _totalPages: number = 1;

  get maxBaseRows() {
    return this._maxBaseRows;
  }
  set maxBaseRows(maxRows) {
    this._maxBaseRows = maxRows;
  }

  get maxBaseColumns() {
    return this._maxBaseColumns;
  }
  set maxBaseColumns(maxBaseColumns) {
    this._maxBaseColumns = maxBaseColumns;
  }

  @action
  setMaxLayout(maxRows: number, maxColumns: number) {
    this._maxBaseRows = maxRows;
    this._maxBaseColumns = maxColumns;
  }
  get currentBaseRows() {
    return this._currentBaseRows;
  }
  set currentBaseRows(currentRows) {
    this._currentBaseRows = currentRows;
  }
  get currentBaseColumns() {
    return this._currentBaseColumns;
  }
  set currentBaseColumns(currentColumns) {
    this._currentBaseColumns = currentColumns;
  }

  @action
  setCurrentBaseLayout(currentBaseRows: number, currentBaseColumns: number) {
    this._currentBaseRows = currentBaseRows;
    this._currentBaseColumns = currentBaseColumns;
  }

  get previousBaseRows() {
    return this._previousBaseRows;
  }
  set previousBaseRows(previousBaseRows) {
    this._previousBaseRows = previousBaseRows;
  }

  get previousBaseColumns() {
    return this._previousBaseColumns;
  }
  set previousBaseColumns(previousBaseColumns) {
    this._previousBaseColumns = previousBaseColumns;
  }

  @action
  setPreviousBaseLayout(previousBaseRows: number, previousBaseColumns: number) {
    this._previousBaseRows = previousBaseRows;
    this._previousBaseColumns = previousBaseColumns;
  }

  set totalPages(totalPages: number) {
    this._totalPages = totalPages;
  }
  get totalPages() {
    return this._totalPages;
  }
}

export default GridLayoutModel;
